<template>
	<div class="layout">
		<div class="layout__header">
			<div class="layout__title">
				<h3>Rubros de nómina</h3>
			</div>
		</div>
		<div class="card">
			<div class="card__content">
				<k-table 
					ref="rubros" 
					@crear="crear" 
					:path="path" 
					@editar="editar" 
					@eliminar="eliminar" 
					:columns="[
						{
							display: 'Código',
							value: 'codigo',
						},
						{
							display: 'Rubro',
							value: 'descripcion',
						},
						{
							display: 'Tipo',
							value: 'tipo_descripcion',
						},
						{
							display: 'Creador',
							value: 'creador.nombre',
						},
						{
							display: 'Creación',
							value: 'created_at',
						},
						{
							display: 'Modificador',
							value: 'modificador.nombre',
						},
						{
							display: 'Modificación',
							value: 'updated_at',
						}
					]"
				></k-table>
			</div>
		</div>
		<modal name="rubro" scrollable resizable reset adaptive height="auto" width="60%">
			<rubro-nomina	
				@cancelar="cancelar"
				@saved="savedRubro" 
				ref="rubro" 
				v-model="selectedRubro"
			></rubro-nomina>
		</modal>
	</div>
</template>

<script>
export default {
	data: function () {
    return {
			path: url + "/rubros-nomina",
      selectedRubro: null,
		}
	},
	methods: {
		cancelar: function () {
      this.$modal.hide("rubro");
    },
		savedRubro: function () {
      this.$modal.hide("rubro");
      this.$refs.rubros.loadRows();
    },
		crear: function () {
      this.selectedRubro = {
        estado: "N",
        codigo: "",
        descripcion: "",
				tipo: "",
        id: "",
        _method: undefined,
      };
      this.$modal.show("rubro");
    },
		editar: function (rubro) {
			this.selectedRubro = {
				codigo: rubro.codigo,
				descripcion: rubro.descripcion,
				estado: rubro.estado,
				tipo: rubro.tipo,
				id: rubro.id,
				_method: "PUT",
			};
			this.$modal.show("rubro");
		},
		eliminar: function (rubro) {
			swal({
        title:
          "¿Deseas " +
          (rubro.estado === "A" ? "inactivar" : "re-activar") +
          " el rubro?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "SI",
        cancelButtonText: "NO",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/rubros/" + rubro.id, {
              _method: "DELETE",
            })
            .then(() => {
              swal(
                "El rubro ha sido " +
                (rubro.estado === "A" ? "inactivado" : "re-activado") +
                ".",
                "Realizado",
                "success"
              );
              this.$refs.rubros.loadRows();
            })
            .catch(() => {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
		}
	}
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/nomina/RubrosNomina.vue